import React, { FC, useEffect, useRef, useState } from 'react'
import { List, Progress, Descriptions, Select, Card, Space } from 'antd'
import { BlockOutlined } from '@ant-design/icons'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { activities, allTech, coreTech, keyTech, priorities } from '@/services/table.service'
import { IAppState } from '@/store/reducers'
// 引入 echarts 核心模块
import * as echarts from 'echarts/core'
import { LegendComponent, GridComponent, TooltipComponent, TitleComponent, DataZoomComponent,
    ToolboxComponent
} from 'echarts/components'
import { CanvasRenderer } from 'echarts/renderers'
// 按需引入图表类型
import { BarChart } from 'echarts/charts'
// import img1 from '@/assets/images/t_1.png'
// import img2 from '@/assets/images/t_2.png'
// import img3 from '@/assets/images/t_3.png'
// import img4 from '@/assets/images/t_4.png'
// import img5 from '@/assets/images/t_5.png'
// import img6 from '@/assets/images/t_7.png'
import { barChart1Option, barChart2Option, barChart3Option, barChart4Option, barChart5Option } from '@/helpers/barChart'
import { getDicClass, ICallbackType, ILegendData } from '@/pages/charts'
import { getLegend, getXAxis } from '@/pages/charts'
import { transPercent } from '@/utils/util'
import _ from 'lodash'
import { t } from 'i18next'
import { getTechTotal } from '@/pages/indexPage'
import { ifvisible } from '@/components/ifvisible.js/main'
import { getWorkgroup } from '@/store/actions/tableEdit.action'

echarts.use([
    BarChart, CanvasRenderer,
    LegendComponent, GridComponent, TooltipComponent, TitleComponent, DataZoomComponent,
    ToolboxComponent
])

const BigScreen: FC = () => {
    const history = useHistory()
    const dispatch = useDispatch()
    const [yearList, setYearList] = useState<any []>([])
    const [max, setMax] = useState<number>(0)
    const [title3, setTitle3] = useState('')
    const [activitiesData, setActivitiesData] = useState<any[]>([])
    const [curSelPlanOrOn, setCurSelPlanOrOn] = useState('PLAN')
    const [chart3Option, setChart3Option] = useState<any>(null)
    const [chart3Data, setChart3Data] = useState<any[]>([])
    const [winW, setWinW] = useState<number>(0)
    const [winH, setWinH] = useState<number>(0)
    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    const [activitiesDataStatus, setActivitiesDataStatus] = useState(false)
    // 是否已获取过dicClassList
    const [gotDic, setGotDic] = useState(false)
    
    const workgroupList = useSelector((state: IAppState) => state.tableEditData.workgroupList)
    const dicClassList = useSelector((state: IAppState) => state.tableEditData.dicClass)

    const chartRef1 = useRef(null)
    const chartRef2 = useRef(null)
    const chartRef3 = useRef(null)
    const chartRef4 = useRef(null)
    const chartRef42 = useRef(null)
    const chartRef5 = useRef(null)
    const chartInstanceArr = useRef<any[]>([])
    const chartInstance3Ref = useRef<any>(null)

    const releaseIfVisibleEvent = (): void => {
        ifvisible.off('idle')
        ifvisible.off('wakeup')
        ifvisible.off('statusChanged')
    }

    const goIndex = () => {
        history.push('/indexPage')
    }
    const getTechTotalFn = async () => {
        const techTotalData = await getTechTotal()
        setMax(techTotalData.max)
        setYearList(techTotalData.yearList)
    }

    const fullOption = (element: any, chartInstance: any, bottom = 250) => ({
        show: true,
        title: '全屏查看',
        right: 5,
        icon: 'path://M928 64H710.4c-14.933333 0-21.333333 17.066667-10.666667 27.733333l93.866667 93.866667-157.866667 157.866667c-12.8 12.8-12.8 32 0 44.8 6.4 6.4 14.933333 8.533333 23.466667 8.533333s17.066667-2.133333 23.466667-8.533333l157.866666-157.866667 93.866667 93.866667c10.666667 10.666667 27.733333 2.133333 27.733333-10.666667V96C960 78.933333 945.066667 64 928 64zM230.4 185.6l93.866667-93.866667c10.666667-10.666667 4.266667-27.733333-10.666667-27.733333H96C78.933333 64 64 78.933333 64 96v217.6c0 14.933333 17.066667 21.333333 27.733333 10.666667l93.866667-93.866667 157.866667 157.866667c6.4 6.4 14.933333 8.533333 23.466666 8.533333s17.066667-2.133333 23.466667-8.533333c12.8-12.8 12.8-32 0-44.8l-160-157.866667zM932.266667 699.733333l-93.866667 93.866667-157.866667-157.866667c-12.8-12.8-32-12.8-44.8 0s-12.8 32 0 44.8l157.866667 157.866667-93.866667 93.866667c-10.666667 10.666667-2.133333 27.733333 10.666667 27.733333h217.6c17.066667 0 32-14.933333 32-32V710.4c0-14.933333-17.066667-21.333333-27.733333-10.666667zM343.466667 635.733333l-157.866667 157.866667-93.866667-93.866667c-10.666667-10.666667-27.733333-4.266667-27.733333 10.666667v217.6c0 17.066667 14.933333 32 32 32h217.6c14.933333 0 21.333333-17.066667 10.666667-27.733333l-93.866667-93.866667 157.866667-157.866667c12.8-12.8 12.8-32 0-44.8s-32-12.8-44.8 0z',
        iconStyle: {
            color: '#036fc0',
            borderColor: '#036fc0'
        },
        onclick: () => {
            if (element.requestFullScreen) {
                element.requestFullScreen()
            } else if (element.msRequestFullscreen) {
                element.msRequestFullScreen()
            } else if (element.webkitRequestFullScreen) {
                element.webkitRequestFullScreen()
            } else if (element.mozRequestFullScreen) {
                element.mozRequestFullScreen()
            }
            const option = chartInstance.getOption()
            console.log('option: ', option)
            const newOption = {
                ...option,
                grid: {
                    ...option.grid,
                    bottom
                },
                xAxis: option.xAxis?.map((xAxi: any) => ({
                    ...xAxi,
                    axisLabel: {
                        ...xAxi.axisLabel,
                        fontSize: 20,
                        overflow: 'none'
                    }
                })),
                series: option.series?.map((serie: any) => ({
                    ...serie,
                    label: {
                        ...serie.label,
                        fontSize: 20,
                    }
                })),
                toolbox: {
                    ...option.toolbox[0],
                    feature: {
                        ...option.toolbox[0].feature,
                        myFull: {
                            ...option.toolbox[0].feature.myFull,
                            show: false
                        },
                        myExitFull: {
                            ...option.toolbox[0].feature.myExitFull,
                            show: true
                        }
                    }
                }
            }
            chartInstance.setOption(newOption)
            setTimeout(() => {
                chartInstance.resize()
            }, 100)
        },
    })
    const exitOption = (element: any, chartInstance: any, bottom = 90) => ({
        show: false,
        title: '退出全屏',
        icon: 'path://M320 128h64v256H128v-64h146.88l-169.6-169.28 45.44-45.44L320 274.88z m416 146.88V128h-64v256h256v-64h-146.88l169.6-169.28-45.44-45.44zM928 704v-64h-256v256h64v-146.88l169.28 169.6 45.44-45.44-169.6-169.28zM128 704h146.88l-169.6 169.28 45.44 45.44 169.28-169.6V896h64v-256H128z',
        iconStyle: {
            color: '#036fc0',
            borderColor: '#036fc0'
        },
        onclick: () => {
            // 退出全屏
            if (document.fullscreenElement) {
                document.exitFullscreen()
            }
            const option = chartInstance.getOption()
            const newOption = {
                ...option,
                grid: {
                    ...option.grid,
                    bottom
                },
                xAxis: option.xAxis?.map((xAxi: any) => ({
                    ...xAxi,
                    axisLabel: {
                        ...xAxi.axisLabel,
                        fontSize: 10,
                        overflow: 'truncate'
                    }
                })),
                series: option.series?.map((serie: any) => ({
                    ...serie,
                    label: {
                        ...serie.label,
                        fontSize: undefined,
                    }
                })),
                toolbox: {
                    ...option.toolbox[0],
                    feature: {
                        ...option.toolbox[0].feature,
                        myFull: {
                            ...option.toolbox[0].feature.myFull,
                            show: true
                        },
                        myExitFull: {
                            ...option.toolbox[0].feature.myExitFull,
                            show: false
                        }
                    }
                }
            }
            chartInstance.setOption(newOption)
            setTimeout(() => {
                chartInstance.resize()
                const childs = element.childNodes
                childs[childs.length - 1].style.display = 'none'
            }, 100)
        }
    })

    const setChart1 = async () => {
        const chart1 = chartRef1.current
        if (chart1) {
            const res = await allTech()
            const lastYear = new Date().getFullYear() - 1
            const legend = [lastYear]
            for (let i = 0; i < 5; i++) {
                legend.push(legend[i] + 1)
            }
            const xAxis: string[] = getXAxis(res, workgroupList)
            const findCont = (xAxisItem: string, legendItem: number | string) => {
                const findObj = res.find(resItem => resItem.workGroupName === xAxisItem && resItem.year === legendItem)
                return findObj || false
            }
            const series: ILegendData[] = getLegend({ legend, xAxis, findCont })
            barChart1Option.legend.data = legend.map(item => item + '')
            barChart1Option.xAxis.data = xAxis
            barChart1Option.series = series
            const chartInstance = echarts.init(chart1)
            chartInstanceArr.current = [...chartInstanceArr.current, chartInstance]
            chartInstance.setOption({
                ...barChart1Option,
                grid: {
                    ...barChart1Option.grid,
                    left: 40,
                    top: 50,
                    bottom: 118
                },
                title: {
                    ...barChart1Option.title,
                    top: 10,
                    textStyle: {
                        color: '#333',
                        fontSize: 14
                    }
                },
                legend: {
                    ...barChart1Option.legend,
                    bottom: 10,
                    textStyle: {
                        color: '#333'
                    }
                },
                dataZoom: [
                    {
                        start: 0,
                        end: 30,
                        height: 10,
                        bottom: 50
                    },
                ],
                xAxis: {
                    ...barChart1Option.xAxis,
                    axisLabel: {
                        ...barChart1Option.xAxis.axisLabel,
                        width: 100,
                        color: '#333'
                    }
                },
                yAxis: {
                    ...barChart1Option.yAxis,
                    axisLabel: {
                        color: '#333'
                    }
                },
                toolbox: {
                    feature: {
                        // 全屏具体实现
                        myFull: fullOption(chart1, chartInstance),
                        myExitFull: exitOption(chart1, chartInstance, 118)
                    },
                }
            })
        }
    }
    const setChart2 = async () => {
        const chart2 = chartRef2.current
        if (chart2) {
            const res = await priorities()
            let legend: string[] = []
            if (Object.keys(dicClassList).length > 0) {
                res.reduce((prev: Record<string, boolean>, item) => {
                    if (!(item.priority in prev)) {
                        prev[item.priority] = true
                        legend.push(item.priority)
                    }
                    return prev
                }, {})
            } else {
                legend = dicClassList['priority'].map(item => item.name)
            }
 
            const findCont = (xAxisItem: string, legendItem: number | string) => {
                const findObj = res.find(resItem => resItem.workGroupName === xAxisItem && resItem.priority === legendItem)
                return findObj || false
            }
            const xAxis: string[] = getXAxis(res, workgroupList)
            const series: ILegendData[] = getLegend({ legend, xAxis, findCont, stack: 'bar1', labelShow: true })
        
            barChart2Option.legend.data = legend.reverse()
            barChart2Option.xAxis.data = xAxis
            barChart2Option.series = series as any
            const chartInstance2 = echarts.init(chart2)
            chartInstanceArr.current = [...chartInstanceArr.current, chartInstance2]
            const arr = barChart2Option.series.map(item => item.data)
            // 把数字转换为百分比
            const arr3: Array<number>[] = transPercent(arr, barChart2Option.legend.data.length)
            const seriesData = barChart2Option.series.map((item, index) => ({
                ...item,
                data: arr3.map(subItem => subItem[index])
            }))
            chartInstance2.setOption({
                ...barChart2Option,
                grid: {
                    ...barChart2Option.grid,
                    left: 60,
                    top: 50,
                    bottom: 85
                },
                title: {
                    ...barChart2Option.title,
                    top: 10,
                    textStyle: {
                        color: '#333',
                        fontSize: 14
                    }
                },
                legend: {
                    ...barChart2Option.legend,
                    textStyle: {
                        color: '#333'
                    }
                },
                label: {
                    // 把百分比显示回原数据
                    formatter(params: any) {
                        try {
                            return barChart2Option.series[params.seriesIndex].data[params.dataIndex]
                        } catch (error) {
                            // console.error(params)
                            // return params.data
                        }
                    }
                },
                tooltip: {
                    ...barChart2Option.tooltip,
                    // 把百分比显示回原数据
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
                    formatter(params: any[], ticket: string, callback: ICallbackType) {
                        const result: string[] = params.map((item: any) => {
                            const value = barChart2Option.series[item.seriesIndex].data[item.dataIndex]
                            return `${item.marker}${item.seriesName}: ${value} ${item.data}%`
                        })
                        // console.log(params, ticket, result.join('<br/>'))
                        // setTimeout(() => {
                        //     callback(ticket, result.join('<br/>'))
                        // }, 0)
                        return params[0].axisValue + '<br/>' + result.reverse().join('<br/>')
                    }
                },
                xAxis: {
                    ...barChart2Option.xAxis,
                    axisLabel: {
                        ...barChart2Option.xAxis.axisLabel,
                        width: 50,
                        color: '#333'
                    }
                },
                yAxis: {
                    ...barChart2Option.yAxis,
                    interval: 20,
                    axisLabel: {
                        ...barChart2Option.yAxis.axisLabel,
                        color: '#333'
                    }
                },
                toolbox: {
                    feature: {
                        // 全屏具体实现
                        myFull: fullOption(chart2, chartInstance2),
                        myExitFull: exitOption(chart2, chartInstance2, 85)
                    },
                },
                series: seriesData
            })
        }
    }
    const setChart3 = async () => {
        const chart3 = chartRef3.current
        if (chart3) {
            const resData = await activities()
            setChart3Data(resData)
            let res = resData
            setActivitiesData(res)
            if (curSelPlanOrOn && curSelPlanOrOn !== 'ALL') {
                res = resData.filter(item => item.status === (curSelPlanOrOn === 'PLAN' ? 1 : 2))
            }
            setActivitiesDataStatus(true)
            const xAxis: string[] = getXAxis(res, workgroupList)
            const lastYear = new Date().getFullYear() - 1
            const legend = []
            for (let i = -1; i < 5; i++) {
                const prevYear = lastYear + i
                if (!curSelPlanOrOn || curSelPlanOrOn === 'ALL') {
                    legend.push((prevYear + 1) + '(On)')
                    legend.push((prevYear + 1) + '(Plan)')
                } else if (curSelPlanOrOn == 'PLAN') {
                    legend.push((prevYear + 1) + '(Plan)')
                } else {
                    legend.push((prevYear + 1) + '(On)')
                }
            }
            setTitle3(t('chartTitle3').replace('2021', '' + lastYear).replace('2026', '' + (lastYear + 5)))
            const findCont = (xAxisItem: string, legendItem: number | string) => {
                const legendItemStr = '' + legendItem
                const findObj = res.find(resItem => resItem.workGroupName === xAxisItem 
                    && ('' + legendItemStr).includes(resItem.year)
                    && (
                        (legendItemStr.includes('Plan') && resItem.status === 1)
                        || (legendItemStr.includes('On') && resItem.status === 2)
                    ))
                return findObj || false
            }
            const series: ILegendData[] = getLegend({ legend, xAxis, findCont })
            barChart3Option.legend.data = legend.map(item => item + '')
            barChart3Option.xAxis.data = xAxis
            barChart3Option.series = series
            if (!chartInstance3Ref.current) {
                const chartInstance3 = echarts.init(chart3)
                chartInstance3Ref.current = chartInstance3
                chartInstanceArr.current = [...chartInstanceArr.current, chartInstance3]
            } else {
                chartInstance3Ref.current.clear()
            }
            let color = barChart3Option.color
            if (curSelPlanOrOn && curSelPlanOrOn !== 'ALL') {
                color = color.filter((item, index) => index % 2 === (curSelPlanOrOn == 'PLAN' ? 0 : 1))
            }
            const option = {
                ...barChart3Option,
                color,
                grid: {
                    ...barChart3Option.grid,
                    left: 60,
                    top: 80,
                    bottom: 118
                },
                title: {
                    ...barChart3Option.title,
                    top: 20,
                    textStyle: {
                        color: '#333'
                    }
                },
                legend: {
                    ...barChart3Option.legend,
                    bottom: 15,
                    textStyle: {
                        color: '#333'
                    }
                },
                xAxis: {
                    ...barChart3Option.xAxis,
                    axisLabel: {
                        ...barChart3Option.xAxis.axisLabel,
                        width: 100,
                        color: '#333'
                    }
                },
                yAxis: {
                    ...barChart3Option.yAxis,
                    axisLabel: {
                        color: '#333'
                    }
                },
                toolbox: {
                    feature: {
                        // 全屏具体实现
                        myFull: fullOption(chart3, chartInstance3Ref.current),
                        myExitFull: exitOption(chart3, chartInstance3Ref.current, 118)
                    },
                },
            }
            setChart3Option(option)
            chartInstance3Ref.current.setOption(option)
        }
    }
    const setChart4 = async (core?: string) => {
        let chart4: any = chartRef4.current
        if (core) {
            chart4 = chartRef42.current
        }
        if (chart4) {
            const chartInstance4 = echarts.init(chart4)
            chartInstanceArr.current = [...chartInstanceArr.current, chartInstance4]
            const _barChart4Option = _.cloneDeep(barChart4Option)
            const option = {
                grid: {
                    ..._barChart4Option.grid,
                    left: 60,
                    top: 50,
                    bottom: 120
                },
                title: {
                    ..._barChart4Option.title,
                    top: 10,
                    textStyle: {
                        color: '#333'
                    }
                },
                legend: {
                    ..._barChart4Option.legend,
                    bottom: 10,
                    textStyle: {
                        color: '#333'
                    }
                },
                xAxis: {
                    ..._barChart4Option.xAxis,
                    axisLabel: {
                        ..._barChart4Option.xAxis.axisLabel,
                        width: 100,
                        color: '#333'
                    }
                },
                yAxis: {
                    ..._barChart4Option.yAxis,
                    interval: 20,
                    axisLabel: {
                        color: '#333'
                    }
                },
                toolbox: {
                    feature: {
                        // 全屏具体实现
                        myFull: fullOption(chart4, chartInstance4),
                        myExitFull: exitOption(chart4, chartInstance4, 120)
                    },
                },
            }
            let res: any[]
            if (core) {
                option.title.text = 'CORE TECHNOLOGY DEVELOPMENT STATUS'
                res = await coreTech()
            } else {
                res = await keyTech()
            }
            if (res.length > 0) {
                let legend: string[] = [..._barChart4Option.legend.data]
                // res.reduce((prev, item) => {
                //     if (!(item.maturity in prev)) {
                //         prev[item.priority] = true
                //         legend.push(item.maturity)
                //     }
                //     return prev
                // }, {})
                if (Object.keys(dicClassList).length > 0) {
                    legend = dicClassList['maturity'].map(item => item.name)
                }
    
                const findCont = (xAxisItem: string, legendItem: number | string) => {
                    const findObj = res.find(resItem => resItem.workGroupName === xAxisItem && resItem.maturity === legendItem)
                    return findObj || false
                }
                const xAxis: string[] = getXAxis(res, workgroupList)
                const series: ILegendData[] = getLegend({ legend, xAxis, findCont, stack: 'bar1', labelShow: true })

                option.legend.data = legend
                option.xAxis.data = xAxis
                
                _barChart4Option.series = series as any
                const arr = series.map(item => item.data)
                // 把数字转换为百分比
                const arr3: Array<number>[] = transPercent(arr, option.legend.data.length)
                const seriesData = series.map((item, index) => ({
                    ...item,
                    data: arr3.map(subItem => subItem[index])
                }))
                chartInstance4.setOption({
                    ..._barChart4Option,
                    ...option,
                    label: {
                        // 把百分比显示回原数据
                        formatter(params: any) {
                            try {
                                return series[params.seriesIndex].data[params.dataIndex]
                            } catch (error) {
                                // console.error(params)
                                // return params.data
                            }
                        }
                    },
                    tooltip: {
                        ..._barChart4Option.tooltip,
                        // 把百分比显示回原数据
                        // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
                        formatter(params: any[], ticket: string, callback: ICallbackType) {
                            const result: string[] = params.map((item: any) => {
                                const value = series[item.seriesIndex].data[item.dataIndex]
                                return `${item.marker}${item.seriesName}: ${value} ${item.data}%`
                            })
                            return params[0].axisValue + '<br/>' + result.join('<br/>')
                        }
                    },
                    series: seriesData
                })
            } else {
                const xAxis: string[] = getXAxis([], workgroupList)
                _barChart4Option.xAxis.data = xAxis
                chartInstance4.setOption({
                    ..._barChart4Option,
                    ...option,
                    series: _barChart4Option.legend.data.map(legendItem => ({
                        type: 'bar',
                        name: legendItem,
                        stack: 'bar1',
                        barMaxWidth: 40,
                        // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
                        data: _barChart4Option.xAxis.data.map(_ => 0)
                    }))
                })
            }
        }
    }
    const getYearSeries = (year: number) => {
        const legend = [`${year}(On)`, `${year}(Plan)`]
        const xAxis = workgroupList.map(workgroupItem => workgroupItem.groupName)
        const findCont = (xAxisItem: string, legendItem: number | string) => {
            const legendItemStr = '' + legendItem
            const findObj = activitiesData.find(resItem => resItem.workGroupName === xAxisItem 
                && ('' + legendItemStr).includes(resItem.year)
                && (
                    (legendItemStr.includes('Plan') && resItem.status === 1)
                    || (legendItemStr.includes('On') && resItem.status === 2)
                ))
            return findObj || false
        }
        const series: ILegendData[] = getLegend({ legend, xAxis, findCont })
        return series
    }
    const setChart5 = () => {
        const year = new Date().getFullYear()
        const chart5: any = chartRef5.current
        if (chart5) {
            const chartInstance = echarts.init(chart5)
            chartInstanceArr.current = [...chartInstanceArr.current, chartInstance]
            const xAxis: string[] = getXAxis([], workgroupList)
            barChart5Option.xAxis.data = xAxis
            barChart5Option.title.text = `DESAY SV ITMT ACTIVITY YR ${year}`
            barChart5Option.legend.data = [`${year}(On)`, `${year}(Plan)`]
            
            const series = getYearSeries(year)
            chartInstance.setOption({
                ...barChart5Option,
                grid: {
                    ...barChart5Option.grid,
                    left: 50,
                    top: 50,
                    bottom: 118
                },
                title: {
                    ...barChart5Option.title,
                    top: 10,
                    textStyle: {
                        color: '#333',
                        fontSize: 14
                    }
                },
                legend: {
                    ...barChart5Option.legend,
                    bottom: 15,
                    textStyle: {
                        color: '#333'
                    }
                },
                xAxis: {
                    ...barChart5Option.xAxis,
                    axisLabel: {
                        ...barChart5Option.xAxis.axisLabel,
                        width: 100,
                        color: '#333'
                    }
                },
                yAxis: {
                    ...barChart5Option.yAxis,
                    splitNumber: 4,
                    axisLabel: {
                        color: '#333'
                    }
                },
                dataZoom: [
                    {
                        start: 0,
                        end: 30,
                        height: 10,
                        bottom: 50
                    },
                ],
                toolbox: {
                    feature: {
                        // 全屏具体实现
                        myFull: fullOption(chart5, chartInstance),
                        myExitFull: exitOption(chart5, chartInstance, 118)
                    },
                },
                series
            })
        }
    }

    const changeChart3 = (e: string) => {
        setCurSelPlanOrOn(e)
        let res = [...chart3Data]
        if (e !== 'ALL') {
            res = chart3Data.filter(item => item.status === (e === 'PLAN' ? 1 : 2))
        }
        const xAxis: string[] = getXAxis(res, workgroupList)
        const lastYear = new Date().getFullYear() - 1
        const legend = []
        for (let i = -1; i < 5; i++) {
            const prevYear = lastYear + i
            if (e === 'ALL') {
                legend.push((prevYear + 1) + '(On)')
                legend.push((prevYear + 1) + '(Plan)')
            } else if (e == 'PLAN') {
                legend.push((prevYear + 1) + '(Plan)')
            } else {
                legend.push((prevYear + 1) + '(On)')
            }
        }
        const findCont = (xAxisItem: string, legendItem: number | string) => {
            const legendItemStr = '' + legendItem
            const findObj = res.find(resItem => resItem.workGroupName === xAxisItem 
                && ('' + legendItemStr).includes(resItem.year)
                && (
                    (legendItemStr.includes('Plan') && resItem.status === 1)
                    || (legendItemStr.includes('On') && resItem.status === 2)
                ))
            return findObj || false
        }
        const series: ILegendData[] = getLegend({ legend, xAxis, findCont })
        let color = barChart3Option.color
        if (e !== 'ALL') {
            color = color.filter((item, index) => index % 2 === (e == 'PLAN' ? 0 : 1))
        }
        const option = {
            ...barChart3Option,
            ...chart3Option
        }
        option.legend.data = legend.map(item => item + '')
        option.xAxis.data = xAxis
        option.series = series
        option.color = color
        chartInstance3Ref.current.clear()
        chartInstance3Ref.current.setOption(option)
    }

    useEffect(() => {
        getTechTotalFn()

        // 避免已获取过后，还是无数据的情况
        if (!gotDic && Object.keys(dicClassList).length === 0) {
            getDicClass(dispatch, setGotDic)
        } else {
            setGotDic(true)
        }

        setTimeout(releaseIfVisibleEvent, 1000)

        if (workgroupList.length === 0) {
            // 获取 workgroupList
            dispatch(getWorkgroup())
        }

        setWinW(document.body.clientWidth)
        setWinH(document.body.clientHeight)
        window.onresize = () => {
            chartInstanceArr.current.forEach(item => {
                item.resize()
            })
            setWinW(document.body.clientWidth)
            setWinH(document.body.clientHeight)
        }
        return () => {
            window.onresize = null
        }
    }, [])
    useEffect(() => {
        if (gotDic && workgroupList.length > 0) {
            setChart1()
            setChart2()
            setChart3()
            setChart4()
            setChart4('core')
        }
    }, [gotDic, workgroupList])
    useEffect(() => {
        if (activitiesData.length) {
            setChart5()
        }
    }, [activitiesData])

    return (
        <div className="big_screen2">
            <h1 style={{ padding: '10px 0', textAlign: 'center', cursor: 'pointer' }} onClick={goIndex}>{t('indexTitle')}</h1>
            <Space size={10} align='start' style={{ padding: '0 10px', width: '100%' }}>
                <Space size={20} direction='vertical' style={{ width: winW * .25 }}>
                    <Descriptions layout='vertical' bordered>
                        <Descriptions.Item label={t('year')}>
                            <List
                                dataSource={yearList}
                                renderItem={item => (
                                    <List.Item>
                                        {item.year}
                                    </List.Item>
                                )}
                            />
                        </Descriptions.Item>
                        <Descriptions.Item label={t('Tech Total')}>
                            <List
                                dataSource={yearList}
                                renderItem={item => (
                                    <List.Item>
                                        <Progress percent={Math.round(item.total / max * 100)} size='default' status='normal'
                                            strokeColor={{
                                                '0%': '#108ee9',
                                                '100%': '#87d068',
                                            }}
                                            format={() => item.total}
                                        />
                                    </List.Item>
                                )}
                            />
                        </Descriptions.Item>
                    </Descriptions>
                    <Card title={<><BlockOutlined /> {t('chartTitle1')}</>} className='title_label'>
                        <div ref={chartRef1} style={{ width: '100%', height: 300, backgroundColor: '#fff' }}></div>
                    </Card>
                </Space>
                <Card title={<><BlockOutlined /> {title3}</>} extra={
                    <Select
                        value={curSelPlanOrOn}
                        style={{ width: 120 }}
                        onChange={changeChart3}
                        options={[
                            {
                                value: 'ALL',
                                label: t('All'),
                            },
                            {
                                value: 'PLAN',
                                label: 'Plan',
                            },
                            {
                                value: 'ON',
                                label: 'On',
                            },
                        ]}
                    />
                } className='title_label' style={{ width: winW * .5 - 40 }}>
                    <div ref={chartRef3} style={{ width: '100%', height: 646, backgroundColor: '#fff' }}></div>
                </Card>
                <Space size={20} direction='vertical' style={{ verticalAlign: 'top', width: winW * .25 }}>
                    <Card title={<><BlockOutlined /> {t('chartTitle2')}</>} className='title_label'>
                        <div ref={chartRef2} style={{ width: '100%', height: 278, backgroundColor: '#fff' }}></div>
                    </Card>
                    <Card title={<><BlockOutlined /> {t('activityTitle')}</>} className='title_label'>
                        <div ref={chartRef5} style={{ width: '100%', height: 300, backgroundColor: '#fff' }}></div>
                    </Card>
                </Space>
            </Space>
            <Space size={10} align='start' style={{ padding: '0 10px', width: '100%' }}>
                <Card title={<><BlockOutlined /> {t('keyTechnologyTitle')}</>} className='title_label' style={{ width: winW * .5 - 15 }}>
                    <div ref={chartRef4} style={{ height: winH - 840, backgroundColor: '#fff' }}></div>
                </Card>
                <Card title={<><BlockOutlined /> {t('coreTechnologyTitle')}</>} className='title_label' style={{ width: winW * .5 - 15 }}>
                    <div ref={chartRef42} style={{ height: winH - 840, backgroundColor: '#fff' }}></div>
                </Card>
            </Space>
        </div>
    )
}

export default BigScreen
